module.exports = __webpack_public_path__ + "img/pulse_v1.ccff5ca9.png";